/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react'

import { getPitchTypeColor } from 'bam-node-baseball-savant/utils/pitch-type-colors'
import getShortPitchName from 'bam-node-baseball-savant/utils/get-short-pitch-name.ts'
import { PitchArsenalDropdownProps } from './utils/types.ts'
import { useDimensions } from './utils/responsive-dimensions.tsx'

export default function PitchArsenalDropdown({
    pitch,
    togglePitchDrawer,
    pitchersWithPitch,
    isExpanded,
    pitchStats,
    renderStatNode,
}: PitchArsenalDropdownProps) {
    const { isMobile } = useDimensions()

    return (
        <div key={pitch} className="stat-picker-drawer-div">
            <div
                onClick={() => togglePitchDrawer(pitch)}
                className="stat-picker-arsenal-drawer"
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between', // Pushes the arrow to the right
                }}
            >
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                    }}
                >
                    <span
                        style={{
                            borderRadius: '4px',
                            padding: '1px 4px',
                            backgroundColor: getPitchTypeColor(
                                pitch.toUpperCase()
                            ),
                            color: pitch === 'sl' ? 'black' : 'white',
                        }}
                    >
                        {getShortPitchName(pitch)}
                    </span>

                    {pitchersWithPitch.length > 0 && (
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                            }}
                        >
                            {pitchersWithPitch.map((player, idx) => {
                                const leftSideMargin =
                                    isMobile && pitchersWithPitch.length > 7
                                        ? '-10px'
                                        : '-8px'
                                const playerId = player.uniqueId
                                return (
                                    <img
                                        key={playerId}
                                        src={`https://midfield.mlbstatic.com/v1/people/${player.id}/mlb/120?circle=true`}
                                        alt="player headshot"
                                        title={player.id.toString() || ''}
                                        style={{
                                            width: '20px',
                                            height: '20px',
                                            borderRadius: '50%',
                                            border: '1px solid #aaaaaa',
                                            backgroundColor: '#e6e6e6',
                                            marginLeft:
                                                idx === 0
                                                    ? '0px'
                                                    : leftSideMargin, // Overlap effect
                                            zIndex:
                                                pitchersWithPitch.length - idx, // Keeps left-most bubble on top
                                        }}
                                    />
                                )
                            })}
                        </div>
                    )}
                </div>
                <span>{isExpanded ? '▾' : '▸'}</span>
            </div>
            {isExpanded && (
                <div className="stat-picker-drawer-stat">
                    {pitchStats.map((stat) => renderStatNode(stat))}
                </div>
            )}
        </div>
    )
}
